<template>
  <button
    :type="submit ? 'submit' : 'button'"
    :disabled="disabled || isLoading"
    @click="$emit('click')"
    class="px-8 py-3 focus:outline-none min-w-32 text-center"
    :class="{
      'rounded  bg-green-500 text-white shadow-sm': type === 'primary',
      'text-green-800 font-bold': type === 'secondary',
      'disabled:opacity-50': type === 'secondary' || disabled,
      'w-full': fullWidth,
      'max-w-max': !fullWidth,
    }"
  >
    <svg  v-if="isLoading" class="inline-block animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
    <slot />
  </button>
</template>

<script>

export default {
  name: 'CommonButton',
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    submit: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/button.vue